import { PlayerUtilitiesService } from './../players/services/player-utilities.service';
import { UserDialogService } from '../profile/services/userdialog.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { StoreModule } from '@ngrx/store';
import { authReducer } from './state/auth.reducer';
import { AuthEffects } from './state/auth.effects';
import { AuthHttpService } from './services/auth.httpservice';
import { AuthInterceptor } from '../shared/interceptors/auth.interceptor';
import { LocationInterceptor } from '../shared/interceptors/location.interceptor';

@NgModule({
	imports: [
		IonicModule,
		EffectsModule.forFeature([AuthEffects]),
		StoreModule.forFeature('auth', authReducer)
	],
	providers: [
		UserDialogService,
		PlayerUtilitiesService,
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: LocationInterceptor, multi: true },
		AuthHttpService
	]
})
export class AuthModule {
	constructor() {

	}
}
